import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import reactCSS, { hover } from 'reactcss';
import { ReduxFormSwitch } from '@ux/switch';
import Panel from '@ux/panel';
import { getStyles, percentage } from '@ux/style-utils';
import { footnote } from '@ux/type-size';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px } from '@ux/theme-utils';
import * as r from 'ramda';

export const stylesheet = ({
  theme,
}) => {
  const {
    palette,
    spacing,
    typography,
  } = theme;

  return {
    default: {
      label: {
        position: 'relative',
        display: 'block',
        height: percentage(100),
        ...cssSides('padding', Side.A, gu2px(2, spacing)),
        ...cssSides('margin', Side.A, 0),
        color: palette.grey02,
        fontWeight: 600,
        ...footnote(typography),
        cursor: 'pointer',
        transition: `
          background-color 0.3s ease-in-out,
          color 0.3s ease-in-out,
          opacity 0.3s ease-in-out
        `,
      },

      switch: {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: gu2px(2, spacing),
      },

      text: {
        verticalAlign: 'middle',
      },

    },

    hover: {
      label: {
        opacity: 0.8,
      },
    },
  };
};

export const stylesheetToStyles = r.unary(reactCSS);

export const PureFilterSwitch = ({
  theme,
  styles,
  label,
  pin,
  input,
}) => (
  <Panel theme={theme}>
    <label
      style={styles.label}
      htmlFor={pin}
    >
      <span style={styles.switch}>
        <ReduxFormSwitch
          theme={theme}
          id={pin}
          input={input}
        />
      </span>
      <span style={styles.text}>
        {label}
      </span>
    </label>
  </Panel>
);

export const enhance = compose(
  setDisplayName('FilterSwitch'),
  hover,
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureFilterSwitch);
